import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerProgressBar',
  props: {
    currentTime: { default: 0 },
    videoDuration: { default: 1 },
    showPlayerProgress: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { currentTime: number, videoDuration: number, showPlayerProgress: boolean };



function formatTime(seconds: number): string {
	const mins = Math.floor(seconds / 60);
	const secs = Math.floor(seconds % 60);
	return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

const formattedCurrentTime = computed(() => formatTime(props.currentTime));
const formattedDuration = computed(() => formatTime(props.videoDuration));

const progressPercent = computed(() => {
	const safeTime = Math.min(props.currentTime, props.videoDuration);
	return (safeTime / props.videoDuration) * 100;
});

return { __sfc: true,props, formatTime, formattedCurrentTime, formattedDuration, progressPercent }
}

})